// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "@babel/polyfill"
import Vue from 'vue'
import Vuex from 'vuex'
import store from './store'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import VueSession from 'vue-session'
import IdleVue from 'idle-vue'
import Moment from 'moment'
import VueCookies from 'vue-cookies'
import html2canvas from 'html2canvas'
import * as htmlToImage from 'html-to-image';

Vue.use(Vuex)
Vue.use(Vuetify)
Vue.use(VueCookies)

var options = {
  persist: true
}
Vue.use(VueSession, options)


const eventsHub = new Vue()
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 3600000
})

Vue.config.productionTip = false

Vue.prototype.$eventBus = new Vue();
Vue.prototype.$toastPosition = 'bottomRight';
Vue.prototype.$toastTimeout = '5000';

Vue.prototype.$requiredField = '* Campo obrigatório';
Vue.prototype.$invalidEmail = '* E-mail inválido';
Vue.prototype.$invalidPassword = '* A password deve conter no minimo 8 carateres (maiúscula, minúscula, alfanumérico, simbolo) ';
Vue.prototype.$invalidTelefone = '* Telefone inválido';
Vue.prototype.$invalidTelemovel = '* Telemóvel inválido';
Vue.prototype.$invalidCodPostal = '* Código postal inválido';

Vue.prototype.$pdfURL = process.env.API_IP +':'+ process.env.API_PORT + '/enesapi/client/pdf/';
Vue.prototype.$fileURL = process.env.API_IP +':'+ process.env.API_PORT + '/enesapi/docs/';
Vue.prototype.$apiURL = process.env.API_IP +':'+ process.env.API_PORT + '/enesapi/';
Vue.prototype.$servicePWD = Number(Moment().format('D')) < 10 ? '!1n0v3.,0'+Moment().format('D') : '!1n0v3.,'+Moment().format('D');

Vue.prototype.$moment = Moment;
Vue.prototype.$html2canvas = html2canvas;
Vue.prototype.$htmlToImage = htmlToImage;
Vue.prototype.$defaultPassword = 'abc123';

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  data () {
    return {
      active: -1
    }
  },
  onIdle() {
    this.active = 0;
    this.$eventBus.$emit('logout');
  },
  onActive() {
    this.active = 1;
  }
})


// WEBPACK FOOTER //
// ./src/main.js